module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_redefine.js
// module id = wm3n
// module chunks = 0